import { format } from 'date-fns';
import { parseBoolean } from './boolean';
import { getCandidateCareerStatus, getCandidateListStatus } from './candidateStatus';
import { formatCandidateDisplayValue } from './formatCandidateField';

export const buildCandidateProfileView = (dbCandidate, alerts = [], calls = []) => {
  if (!dbCandidate) return null;

  let skills = [];
  if (dbCandidate.skills) {
    try {
      skills = typeof dbCandidate.skills === 'string'
        ? JSON.parse(dbCandidate.skills)
        : dbCandidate.skills;
    } catch {
      skills = [];
    }
  }

  const careerStatus = getCandidateCareerStatus(dbCandidate);
  const status = getCandidateListStatus(dbCandidate);

  const linkedinAlerts = alerts.filter((alert) =>
    alert.alert_type === 'new_post' || alert.alert_type === 'new_certification'
  );
  const lastLinkedInCheck = dbCandidate.scraped_time
    ? format(new Date(dbCandidate.scraped_time), 'dd-MM-yyyy')
    : 'N/A';

  const lastCheckNew = linkedinAlerts.length > 0
    && (new Date() - new Date(linkedinAlerts[0].created_at)) < 3 * 24 * 60 * 60 * 1000;

  const lastCall = calls[0] ?? null;
  const callHistory = calls.slice(1).map((call) => ({
    id: call.id,
    created_at: call.created_at,
    status: call.status ?? null,
    ai_summary: call.ai_summary?.trim?.() || 'No summary available.',
  }));

  const lastCallAt = lastCall?.created_at ?? null;
  const lastCallStatus = lastCall?.status ?? null;

  const locationParts = [];
  for (const value of [dbCandidate.country, dbCandidate.city, dbCandidate.location]) {
    const part = String(value ?? '').trim();
    if (!part) continue;
    if (locationParts.some((existing) => existing.toLowerCase() === part.toLowerCase())) continue;
    locationParts.push(part);
  }
  const locationDisplay = locationParts.join(', ') || 'Not specified';

  return {
    id: dbCandidate.id,
    name: dbCandidate.full_name || 'Unknown',
    avatar: dbCandidate.avatar || null,
    avatarAlt: `${dbCandidate.full_name} profile`,
    location: formatCandidateDisplayValue(locationDisplay),
    currentPosition: formatCandidateDisplayValue(dbCandidate.current_position || 'Not specified'),
    company: formatCandidateDisplayValue(dbCandidate.current_company || 'Not specified'),
    skills,
    careerStatus,
    status,
    lastLinkedInCheck,
    lastCheckNew,
    lastCallAt,
    lastCallStatus,
    callSummary: lastCall?.ai_summary?.trim?.() || 'No AI calls recorded yet.',
    callHistory,
    additionalActivity: dbCandidate.certifications || null,
    email: dbCandidate.email,
    phone: dbCandidate.phone,
    isPrioritized: dbCandidate.prioritize || false,
    linkedinUrl: dbCandidate.linkedin_url,
    isInvalidLink: parseBoolean(dbCandidate.invalid_link),
    isManualOpenToWork: parseBoolean(dbCandidate.is_open_to_work_manual),
    isFromZoho: Boolean(String(dbCandidate.zoho_id ?? '').trim()),
    hasScraped: Boolean(dbCandidate.scraped_time && String(dbCandidate.scraped_time).trim()),
    manualOpenToWorkAt: dbCandidate.is_open_to_work_manual_at
      ? format(new Date(dbCandidate.is_open_to_work_manual_at), 'dd-MM-yyyy')
      : null,
    reasoningOpenToWork: dbCandidate.reasoning_open_to_work?.trim?.() || null,
    _original: dbCandidate,
  };
};
